/* eslint-disable no-console */
import axios from 'axios';
import store from '../store';
/**
 * Request Wrapper with default success/error actions
 */

const siteRequest = options => {
    /**
     * Create an Axios Client with defaults
     */

    const { sites, key } = store.getState().license.active;
    const client = axios.create({
        baseURL: `https://${sites[0]}`,
        headers: {
            token: key
        }
    });

    const onSuccess = response => {
        // console.debug('Request Successful!', response);
        return response.data;
    };

    const onError = error => {
        if (error.response) {
            // Request was made but server responded with something
            // other than 2xx
            // console.error('Status:', error.response.status);
            // console.error('Data:', error.response.data);
            // console.error('Headers:', error.response.headers);
        } else {
            // Something else happened while setting up the request
            // triggered the error
            console.error('Error Message:', error.message);
        }

        return Promise.reject(error.response || error.message);
    };
    return client(options)
    .then(onSuccess)
    .catch(onError);
};

export default siteRequest;
